import { Controller } from "@hotwired/stimulus"

// Autosave de formulário inteiro (confirmação de dados). O checklist já salva
// resposta a resposta; aqui o que se preenche é um formulário só, então ele vai
// inteiro — com a mesma pausa de digitação e o mesmo aviso flutuante, para a
// tela responder igual em toda a OS.
const TYPING_DEBOUNCE_MS = 900

const STATUS_PILL = "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm shadow-lg"
const STATUS_TONES = {
  saving: "bg-gray-900/90 text-white",
  success: "bg-gray-900/90 text-white",
  error: "bg-red-600 text-white"
}

export default class extends Controller {
  static targets = [ "status" ]

  disconnect() {
    clearTimeout(this.timer)
    clearTimeout(this.statusTimer)
  }

  save(event) {
    clearTimeout(this.timer)
    // Escolha (select, radio, data) já é decisão tomada; texto espera a pausa.
    const delay = event?.type === "input" ? TYPING_DEBOUNCE_MS : 0
    this.timer = setTimeout(() => this.send(), delay)
  }

  async send() {
    const body = new FormData(this.element)
    body.append("draft", "1")
    this.showStatus("Salvando…")

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        },
        body: body
      })
      if (response.ok) {
        this.showStatus("Salvo ✓", "success")
      } else {
        this.showStatus("Erro ao salvar — tente novamente", "error")
      }
    } catch {
      this.showStatus("Sem conexão — tente novamente antes de sair da página", "error")
    }
  }

  // Some sozinho quando deu certo; erro fica, porque sair da página achando que
  // salvou é o que não pode acontecer.
  showStatus(text, tone = "saving") {
    if (!this.hasStatusTarget) return

    clearTimeout(this.statusTimer)
    const pill = this.statusTarget
    pill.textContent = text
    pill.className = `${STATUS_PILL} ${STATUS_TONES[tone]}`
    pill.hidden = false

    if (tone === "success") {
      this.statusTimer = setTimeout(() => { pill.hidden = true }, 2000)
    }
  }
}
